import { FC, ReactNode } from "react";
import { useAbility } from "configs/casl";
import { PermissionRequirement } from "constants/types/permission";
import { canAccessRequirement } from "utils/helpers/authorization";

interface Props {
  required?: PermissionRequirement;
  children: ReactNode;
}

const RequireRoutePermission: FC<Props> = ({ required, children }) => {
  const ability = useAbility();

  if (!required || canAccessRequirement(ability, required)) {
    return <>{children}</>;
  }

  // Throw để ErrorBoundary bắt và render trang 403
  throw { statusCode: 403 };
};

export default RequireRoutePermission;
